import loader from '../utils/loader'
import ajaxCreator from './ajax'
import * as ajaxEventKeyMap from './ajax/EventKeys'

const apiModuleMap = loader.getByFileName(require.context('./modules', true, /\/[A-Z][^\s/]*?\.js/))

export default {
  install (Vue, param) {
    let vuePrototype = Vue.prototype

    if (vuePrototype.api === apiModuleMap) {
      return
    }

    param.options = {
      baseURL: process.env.API_HOST,
      timeout: 60000
    }

    const sourceMap = param.sourceMap = {}

    const ajax = ajaxCreator(param)
    // const REQUEST_METHOD_MAP = process.env.REQUEST_METHOD_MAP

    for (let key in apiModuleMap) {
      apiModuleMap[key] = Object.entries(apiModuleMap[key]).reduce((map, [apiKey, api]) => {
        const sourceKey = `${key}/${apiKey}`

        map[apiKey] = (...param) => {
          let config = api(...param)
          config.sourceKey = sourceKey

          return ajax(config)
        }

        return map
      }, {})
    }

    vuePrototype.$api = apiModuleMap
    vuePrototype.$cancelRequests = requestNames => requestNames.forEach(requestName => {
      let source = sourceMap[requestName]

      if (source) {
        source.cancel(ajaxEventKeyMap.REQUEST_CANCEL)
        delete sourceMap[requestName]
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/index.js